export default __webpack_public_path__ + "static/media/test-white.6e6a71e8.svg";